import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'react-toolbox/lib/button';
import { GuestFieldsContainer, GuestNameField } from '../styles';

const Guest = ({
  guestNumber,
  inputProps,
  onChange,
  value,
  error,
  disabled,
  onBlur,
  deleteGuestClick,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        marginBottom: '8px',
        borderRadius: '4px',
        border: '1px solid #e1e1e1',
        backgroundColor: 'transparent',
      }}
    >
      <GuestFieldsContainer>
        <GuestNameField
          label={`Guest #${guestNumber} First Name`}
          value={value.firstName}
          error={error.firstName}
          onChange={onChange('firstName')}
          onBlur={onBlur}
          disabled={disabled}
          validation={[
            {
              checkValid: value => (value || '').length <= 30,
              message: 'First Name must not exceed 30 characters.',
              events: ['onChange'],
            },
            {
              pattern: /^[a-z\-\s.]*$/i,
              message: 'Valid names can contain letters, a hyphen, and a period.',
              events: ['onChange'],
            },
          ]}
          maxLength={30}
          counter={true}
          {...inputProps}
        />
        <GuestNameField
          label={`Guest #${guestNumber} Last Name`}
          value={value.lastName}
          error={error.lastName}
          onChange={onChange('lastName')}
          onBlur={onBlur}
          disabled={disabled}
          validation={[
            {
              checkValid: value => (value || '').length <= 30,
              message: 'Last Name must not exceed 30 characters.',
              events: ['onChange'],
            },
            {
              pattern: /^[a-z\-\s.]*$/i,
              message: 'Valid names can contain letters, a hyphen, and a period.',
              events: ['onChange'],
            },
          ]}
          maxLength={30}
          counter={true}
          {...inputProps}
        />
      </GuestFieldsContainer>
      {typeof deleteGuestClick === 'function'
        ? <IconButton
            icon="clear"
            neutral={false}
            type="button"
            onClick={deleteGuestClick}
            style={{ color: '#a4a4a4', alignSelf: 'flex-start' }}
            ripple={false}
          />
        : null}
    </div>
  );
};

Guest.propTypes = {
  number: PropTypes.number,
};

export default Guest;



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/RegistrationForm/GuestList/Guest.js